import { render, staticRenderFns } from "./AddEidtSubform.vue?vue&type=template&id=3e15474c&scoped=true&"
import script from "./AddEidtSubform.vue?vue&type=script&lang=js&"
export * from "./AddEidtSubform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e15474c",
  null
  
)

export default component.exports